export class UrlConstants {
    public static AUTHENTICATE_URI = '/paymentservice/authentication/authenticateUser';
    public static QD_INSTRUMENTS_URI = '/paymentservice/deposit/qdinstruments';
    public static USER_DATA_URI = '/paymentservice/user-data/config';
    public static FX_RATES_URI = '/paymentservice/deposit/fx-rates';
    public static REVERSALS_URI = '/paymentservice/cashout/pending';
    public static REVERSALS_SUBMIT_URI = '/paymentservice/cashout/reverse';
    public static DEPOSIT_SUBMIT = '/paymentservice/deposit/submit';
    public static THREEDSMETHOD_STATUS_URI = '/paymentservice/deposit/threeds-data';
    public static REDIRECTION_DATA_URI = '/paymentservice/deposit/creditcard-get-redirect-url';
    public static DEPOSIT_STATUS_URI = '/paymentservice/deposit/status';
    public static STAKE_AMOUNT_URI = '/paymentservice/stake/pending-amount';
    public static VALIDATE_BONUS_URI = '/paymentservice/deposit/validatebonus';
    public static GET_RG_LIMIT_INFO = '/paymentservice/user-data/rgLimit-info';
    public static DEPOSIT_CURFEW_DETAILS_URI = '/paymentservice/deposit/deposit-curfew';
    public static ZENDESK_CHAT_TOKEN = '/paymentservice/user-data/token';
    public static THEME_TO_LOAD_URL = '/paymentservice/qd/cashier-theme';
    public static LIVE_CHAT_ES_LINK = '/mobileportal/contact?showContact=true&keyword=customerprotectionint';
    public static MORE_INFO_ES_LINK = '/p/legal/general/intensive-spain';
    public static DEPOSIT_SUBMIT_URI = '/paymentservice/deposit/submit';
    public static APPLEPAY_EXECUTE = '/depositservice/deposit/execute';
    public static GET_APPLEPAY_SESSION = '/paymentservice/deposit/getApplepaySession';
    public static EXCEPTION_END_URI = '/paymentservice/deposit/console-log';
    public static DEPOSIT_SUCCESS_URI = '/paymentservice/deposit/successTime';
    public static AFF_MAXLOSS_TOGGLE_INTERCEPTOR = '/paymentservice/deposit/toggle-interceptor';
    public static OCCUPATIONAL_DETAILS = '/paymentservice/user-data/es-ltm-occupation-details';
    public static CLOSE_VAT_TAX_MESSAGE = '/paymentservice/user-data/closeTaxMessage';
    public static DEPOSIT_CAP_EXCEED_ALERT = '/paymentservice/user-data/depositCapExceedAlert';
    public static UPDATE_DNAID_CONFIG = '/paymentservice/deposit/updateDnaIdConfig';
}
